module.exports = __webpack_public_path__ + "static/media/Barcelona_1-DSC_0150.e4591e0d.jpg";